import { supabase } from "@/integrations/supabase/client";

export const uploadAvatar = async (userId: string, imageBlob: Blob): Promise<string | null> => {
  try {
    const fileExt = imageBlob.type.split('/')[1] || 'jpg';
    const timestamp = Date.now();
    const fileName = `${userId}/avatar-${timestamp}.${fileExt}`;

    const { data: existingFiles } = await supabase.storage
      .from('avatars')
      .list(userId);
    
    if (existingFiles && existingFiles.length > 0) {
      const filesToRemove = existingFiles.map(file => `${userId}/${file.name}`);
      await supabase.storage
        .from('avatars')
        .remove(filesToRemove);
    }

    const { error: uploadError } = await supabase.storage
      .from('avatars')
      .upload(fileName, imageBlob, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) throw uploadError;

    const { data: { publicUrl } } = supabase.storage
      .from('avatars')
      .getPublicUrl(fileName);

    return publicUrl;
  } catch (error) {
    console.error('Error uploading avatar:', error);
    return null;
  }
};

export const deleteAvatar = async (userId: string): Promise<boolean> => {
  try {
    const { data: existingFiles } = await supabase.storage
      .from('avatars')
      .list(userId);
    
    if (existingFiles && existingFiles.length > 0) {
      const filesToRemove = existingFiles.map(file => `${userId}/${file.name}`);
      const { error } = await supabase.storage
        .from('avatars')
        .remove(filesToRemove);
      
      if (error) throw error;
    }

    return true;
  } catch (error) {
    console.error('Error deleting avatar:', error);
    return false;
  }
};

